var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostpaidLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 35,
    viewBox: "0 0 30 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5813 0H0V28.5215H14.5813C22.6342 28.5215 29.1626 22.1366 29.1626 14.2607C29.1626 6.38491 22.6342 0 14.5813 0ZM6.62413 12.2416C4.93563 12.2416 3.56842 10.9045 3.56842 9.2531C3.56842 7.60172 4.93563 6.26456 6.62413 6.26456C8.31263 6.26456 9.67984 7.60172 9.67984 9.2531C9.67984 10.9045 8.31263 12.2416 6.62413 12.2416Z",
    fill: "#1B4DF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62413 35C10.2825 35 13.2483 32.0995 13.2483 28.5215C13.2483 24.9435 10.2825 22.043 6.62413 22.043C2.96572 22.043 0 24.9435 0 28.5215C0 32.0995 2.96572 35 6.62413 35Z",
    fill: "#142657"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostpaidLogo);
export default __webpack_public_path__ + "static/media/postpaidLogo.bd65f1848a68e153f49dab0c79b947a4.svg";
export { ForwardRef as ReactComponent };